import { GlobalSettings } from "../global_settings.js";
import { AppVersionController } from "./controllers/app_version_controller.js";
import { CustomEventsController } from "./controllers/custom_events_controller.js";
import { SessionController } from "./controllers/session_controller.js";
import { ServerController } from "./server_controller.js";

export class SocketHandler
{
  private readonly server: ServerController;

  constructor()
  {
    this.server = new ServerController( GlobalSettings.WEBSOCKET_URL );
    this.server.clearHandlers();
    SessionController.register( this.server );
    CustomEventsController.register( this.server );
    AppVersionController.register( this.server );
    this.server.onDisconnect( () => CustomEventsController.markSessionUnavailable() );
    this.server.onReconnect( () =>
    {
      CustomEventsController.markSessionUnavailable();
      void SessionController.sendStartSession( true );
    } );
    this.server.connect();
  }

  public disconnect(): void
  {
    this.server.disconnect();
  }
}
